import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

type RowSize = 'half' | 'full';

type RowProps = {
  size: RowSize;
};

const rowResponsiveHalf = media.phone`
  width: calc(50% - 6.5px);
  flex-grow: 0;
  white-space: pre-wrap;
  align-items: flex-start;
`;

const rowResponsiveFull = media.phone`
  min-width: auto;
`;

const variants: { [key in RowSize]: ReturnType<typeof css> } = {
  half: css`
    display: inline-flex;
    width: 50%;
    margin-bottom: 18px;
    max-width: 190px;
    white-space: nowrap;

    &:nth-child(odd) {
      width: calc(50% - 10px);
      ${rowResponsiveHalf}
    }

    &:nth-child(even) {
      width: calc(50% + 10px);
      ${rowResponsiveHalf}
    }
  `,
  full: css`
    display: flex;
    ${rowResponsiveFull};
  `
};

export const Row = styled.div<RowProps>`
  flex-grow: 1;
  align-items: center;
  max-width: 100%;
  > * {
    flex: 1;
    max-width: 100%;
  }

  ${({ size }) => variants[size]}
`;

const formWrapperResponsive = media.tablet`
  padding: 10px 19px 18px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 101px;
  ${formWrapperResponsive};
`;

const saveButtonResponsive = media.tablet`
  margin: 0 auto;
`;

const saveButtonMobile = media.phone`
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0;
`;

export const SaveButton = styled(ButtonLoader)`
  margin-top: 10px;
  ${saveButtonResponsive};
  ${saveButtonMobile};
`;
